var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsLightningLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Lightning_Line",
    "data-name": "icons/Lightning/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.746,
    height: 15.945,
    viewBox: "0 0 9.746 15.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.482,15.945A.612.612,0,0,1,3,15.7a.7.7,0,0,1-.128-.536l.786-5.194H.607A.592.592,0,0,1,.068,9.61a.712.712,0,0,1,.048-.694L5.782.279A.571.571,0,0,1,6.264,0a.611.611,0,0,1,.478.243A.7.7,0,0,1,6.87.779L6.084,5.972H9.139a.592.592,0,0,1,.539.363.712.712,0,0,1-.048.694L3.964,15.666A.571.571,0,0,1,3.482,15.945ZM5.251,3.366,1.791,8.639h3.3l-.6,3.94L7.954,7.306h-3.3Z",
    transform: "translate(0)",
    fill: "#fcfcfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLightningLine);
export default __webpack_public_path__ + "static/media/iconsLightningLine.abf51c32eb2752545f709392423e835f.svg";
export { ForwardRef as ReactComponent };